<template>
  <div class="register">
    <header-top></header-top>
    <div class="logo-view">
      <div class="logo">
        <img :src="logo" alt="">
      </div>
    </div>
    <div class="content">
      <div v-if="!view" class="view1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="重置密码：" prop="userPass">
            <el-input type="password"
            placeholder="请输入长度8~16位数字、字母、字符至少包含两种的密码"
            suffix-icon="iconfont ys-ai-password"
            v-model="ruleForm.userPass" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
          </el-form-item>
          <el-form-item label="确认密码：" prop="confirmPass">
            <el-input type="password" v-model.number="ruleForm.confirmPass" placeholder="请确认密码" suffix-icon="iconfont ys-ai-password"></el-input>
          </el-form-item>
          <el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button class="nextBtn" type="text" @click="submitForm('ruleForm')">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-else class="view2">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm1" label-width="120px" class="demo-ruleForm">
          <el-form-item label="绑定手机：" prop="phone">
            <el-input type="text"
            maxlength="11"
            placeholder="请输入手机号"
            v-model="ruleForm.phone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
          </el-form-item>
        </el-form>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm2" label-width="120px" class="demo-ruleForm">
          <el-form-item label="短信验证码：" prop="msgCode">
            <el-col :span="8">
              <el-input type="text" v-model.number="ruleForm.msgCode" maxlength="6" placeholder="请输入验证码"></el-input>
            </el-col>
            <el-col :span="11" class="btns">
              <el-button :disabled='disabled' type="danger" @click="getCode('ruleForm1')">获取短信验证</el-button>
            </el-col>
            <el-col :span="5" class="btns">
              <span v-show="time > 0">{{time}}s</span>
            </el-col>
          </el-form-item>
          <el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button class="nextBtn" type="text" @click="goRegister('ruleForm1','ruleForm2')">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/base/header/header'
export default {
  name: 'register',
  components: {
    'header-top': Header
  },
  data () {
    var validateUserPass = (rule, value, callback) => {
      const regex = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/
      if (value === '') {
        callback(new Error('密码不能为空！'))
      } else if (!regex.test(value)) {
        callback(new Error('密码长度8~16位数字、字母、字符至少包含两种！'))
      } else {
        callback()
      }
    }
    var validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.userPass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      var reg = /^1[34578]\d{9}$/
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validateMsgCode = (rule, value, callback) => {
      let reg = /^\d{6}$/
      if (value === '') {
        callback(new Error('短信验证码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入6位的数字'))
      } else {
        callback()
      }
    }
    return {
      logo: require('@/assets/images/login/logo.png'),
      hy: require('@/assets/images/login/hy.png'),
      checked: true,
      disabled: false,
      time: 0,
      view: true,
      ruleForm: {
        userPass: '',
        confirmPass: '',
        phone: '',
        msgCode: ''
      },
      rules: {
        userPass: [
          { required: true, validator: validateUserPass, trigger: 'blur' }
        ],
        confirmPass: [
          { required: true, validator: validateConfirmPass, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        msgCode: [
          { required: true, validator: validateMsgCode, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      let self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const tel = self.ruleForm.phone
          // const password = self.ruleForm.userPass
          const password = self.$md5(self.ruleForm.userPass)
          const checkCode = self.ruleForm.msgCode
          const url = `?tel=${tel}&password=${password}&checkCode=${checkCode}`
          self.$get(self.$allUrl.resetPassword + url).then(res => {
            if (res.code === '0') {
              self.$message({
                message: '恭喜您，修改成功！',
                type: 'success',
                onClose: function () {
                  self.$router.push({
                    name: 'Login'
                  })
                }
              })
            } else {
              self.$notify.error({
                title: '错误',
                message: res.message
              })
            }
          })
        } else {
          return false
        }
      })
    },
    getCode (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.countDown()
        } else {
          return false
        }
      })
    },
    goRegister (formName1, formName2) {
      const self = this
      let flag = true
      self.$refs[formName1].validate((valid) => {
        if (valid) {
        } else {
          flag = false
          return false
        }
      })
      self.$refs[formName2].validate((valid) => {
        if (valid) {
        } else {
          flag = false
          return false
        }
      })
      if (flag) {
        self.view = false
      }
    },
    countDown () { // 倒计时
      const self = this
      self.disabled = true
      const tel = self.ruleForm.phone
      self.$get(self.$allUrl.getSendVerifyCode + `?tel=${tel}`).then(res => {
        if (res.code === '0') {
          self.time = 60
          const int = setInterval(function () {
            if (self.time > 1) {
              self.time -= 1
            } else {
              window.clearInterval(int)
              self.time = 0
              self.disabled = false
            }
          }, 1000)
        } else {
          self.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
      // const int = setInterval(function () {
      //   if (self.time > 1) {
      //     self.time -= 1
      //   } else {
      //     window.clearInterval(int)
      //     self.time = 0
      //     self.disabled = false
      //   }
      // }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
  .register{
    width: 1200px;
    min-height: 1000px;
    margin: auto;
    background: white;
    .logo-view{
      display: flex;
      padding: 20px 120px;
      .logo{
        border-right: 1px solid #dddddd;
        padding: 0 20px 0 0;
      }
      .welcome{
        padding-left: 20px;
        img{
          margin-top: 20px;
        }
      }
    }
    .goLogin{
      text-align: right;
      font-size: 12px;
      padding: 0 120px;
      span{
        color: red;
        cursor: pointer;
      }
    }
    .content{
      padding: 0 120px;
      .nextBtn{
          width: 100%;
          background-image: url('../../assets/images/login/dl.png');
          background-repeat: no-repeat;
          background-size:100% 100%;
          height: 50px;
          color: #ffd2d9;
          font-size: 20px;
        }
      .view1, .view2{
        border: 1px solid #dddddd;
        padding: 40px 250px;
        .btns{
          padding-left: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/retrievePass.vue


// WEBPACK FOOTER //
// src/components/Login/retrievePass.vue